

import React, { useEffect, useState } from "react";

const Tabs = ({ activeTab, setActiveTab, onSaveClick, dashboardId, productId }) => {
  const tabs = ["Summary", "Error Details", "Rule Catalogue"];
  const [productName, setProductName] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [isSaved, setIsSaved] = useState(false);
  const [copied, setCopied] = useState(false);
  

  useEffect(() => {
    const name = localStorage.getItem("selectedProductName");
    if (name) {
      setProductName(name);
    }
  }, []);
  useEffect(() => {
  const params = new URLSearchParams(window.location.search);
  const sharedProduct = params.get("product");

  if (sharedProduct) {
    setProductName(sharedProduct); // override localStorage
  }
}, []);


  const origin = window.location.origin;

  // Build share URLs only if dashboardId exists
const encodedProduct = encodeURIComponent(productName);

const shareUrls = dashboardId
  ? {
      summary: `${origin}/product-report/dashboard-view/${dashboardId}?tab=Summary&product=${encodedProduct}`,
      errorDetails: `${origin}/product-report/dashboard-view/${dashboardId}?tab=Error+Details&product=${encodedProduct}`,
      ruleCatalogue: `${origin}/product-report/dashboard-view/${dashboardId}?tab=Rule+Catalogue&product=${encodedProduct}`,
    }
  : null;


      const showToast = (message) => {
    setToastMessage(message);
    setTimeout(() => setToastMessage(""), 3000);
  };

  return (
    <div className="tabs-container">
    {toastMessage && (
  <div
    className="fixed top-13 left-1/2 transform -translate-x-1/2 bg-[#bb1ccc] text-white   px-6 py-3 rounded shadow-md z-[3000] text-center font-medium"
  >
    {toastMessage}
  </div>
)}
      {/* Left side title */}
      <div className="tabs-title">
        {productName ? `${productName} ` : "Product Report"}
      </div>

      {/* Right side: tabs + buttons */}
      <div className="flex items-center gap-4">
        {/* Tabs */}
        <div className="tabs">
          {tabs.map((tab) => (
            <button
              key={tab}
              className={`tab ${activeTab === tab ? "active" : ""}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>

        {/* Buttons */}
        <div className="flex space-x-2">
          <button
            className="bg-[#bb1ccc] text-white font-medium px-4 py-2 rounded "
onClick={() => {
  onSaveClick();
  setIsSaved(true); // highlight Share button
  setTimeout(() => setIsSaved(false),  15000); 
}}          >
            Save
          </button>
          <button
className={`${
    isSaved
      ? "bg-green-600 text-white"
      : "bg-gray-200 text-gray-800"
  } font-medium px-4 py-2 rounded `}
            onClick={() => {
              if (!dashboardId) {
                showToast("⚠️ Please save the dashboard before sharing it.");
                return;
              }
              setShowModal(true);
            }}
          >
            Share
          </button>
        </div>
      </div>

      {/* Modal for Share Links */}
{showModal && shareUrls && (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: "rgba(0,0,0,0.5)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 2000,
    }}
  >
    <div
      style={{
        background: "#fff",
        padding: "20px",
        borderRadius: "8px",
        minWidth: "400px",
      }}
    >
      <h3 className="font-semibold mb-3">Share Dashboard Links</h3>
     <div className="space-y-3">
  <div>
    {/* <strong>{activeTab}:</strong> */}
    <div className="flex gap-2 mt-1">
      <input
        readOnly
        value={
          activeTab === "Summary"
            ? shareUrls.summary
            : activeTab === "Error Details"
            ? shareUrls.errorDetails
            : shareUrls.ruleCatalogue
        }
        className="w-full border px-2 py-1 rounded"
        onClick={(e) => e.target.select()}
      />
 
<button
  className="bg-[#bb1ccc] text-white px-3 py-1 rounded"
  onClick={() => {
    const textToCopy =
      activeTab === "Summary"
        ? shareUrls.summary
        : activeTab === "Error Details"
        ? shareUrls.errorDetails
        : shareUrls.ruleCatalogue;

    navigator.clipboard.writeText(textToCopy);
    setCopied(true);
  }}
>
  {copied ? "Copied" : "Copy"}
</button>




    </div>
  </div>
</div>

      <div className="mt-6 flex justify-end">
        <button
  className="bg-[#bb1ccc] text-white px-4 py-2 rounded"
  onClick={() => {
    setCopied(false);
    setShowModal(false);
  }}
>
  Close
</button>
      </div>
    </div>
  </div>
)}   
 </div>
  );
};

export default Tabs;
